import { Action } from '@ngrx/store';
import {DeviceMonitoringData, DeviceMonitoringFilter} from '../../../models/devices';

export enum DeviceMonitoringActionTypes {
  LoadDeviceMonitorings = '[DeviceMonitoring] Load DeviceMonitorings',
  GetDeviceMonitorings = '[DeviceMonitoring] Get DeviceMonitorings',
  GetDeviceMonitoringsFail = '[DeviceMonitoring] Get DeviceMonitorings Fail',
  UpsertDeviceMonitorings = '[DeviceMonitoring] Upsert DeviceMonitorings',
  NoDeviceMonitoringsChanged = '[DeviceMonitoring] No DeviceMonitorings Changed',
}

export class LoadDeviceMonitorings implements Action {
  readonly type = DeviceMonitoringActionTypes.LoadDeviceMonitorings;
  constructor(public payload: { deviceMonitorings: DeviceMonitoringData[]}) {}
}

export class GetDeviceMonitorings implements Action {
  readonly type = DeviceMonitoringActionTypes.GetDeviceMonitorings;
  constructor(public payload: DeviceMonitoringFilter) {}
}

export class GetDeviceMonitoringFail implements Action {
  readonly type = DeviceMonitoringActionTypes.GetDeviceMonitoringsFail;
}

export class UpsertDeviceMonitorings implements Action {
  readonly type = DeviceMonitoringActionTypes.UpsertDeviceMonitorings;
  constructor(public payload: { deviceMonitorings: DeviceMonitoringData[]}) {}
}

export class NoDeviceMonitoringsChanged implements Action {
  readonly type = DeviceMonitoringActionTypes.NoDeviceMonitoringsChanged;
}


export type DeviceMonitoringActions = LoadDeviceMonitorings
  | GetDeviceMonitorings
  | GetDeviceMonitoringFail
  | UpsertDeviceMonitorings
  | NoDeviceMonitoringsChanged;
